import {QueryClient} from '@tanstack/react-query'
export const reactQueryClient = new QueryClient()
import { useState, useEffect } from 'react';

export const useResizeObserver = (selector?: string) => {
    const [inPageNavOffset, setInPageNavOffset] = useState(58);

    useEffect(() => {
        const element = document.querySelector(selector || '.tc-bar-header.ui-site-header') as HTMLElement;
        if (!element) {
            return
        }
        const resizeObserver = new ResizeObserver(() => {
            setInPageNavOffset(element.offsetHeight);
        });
        resizeObserver.observe(element);
        return () => resizeObserver.disconnect();
    }, [selector]);

    return inPageNavOffset;
};

